import { defineStore } from 'pinia'
import { http, initTokenRefresh } from '@/utils/request'
import { usePermissionStore } from './permission'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('token') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    roles: JSON.parse(localStorage.getItem('roles') || '[]'),
    permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
    isAdmin: (state) => state.roles.includes('ADMIN') || state.roles.includes('SUPER_ADMIN') || state.roles.includes('ROLE_ADMIN') || state.roles.includes('ROLE_SUPER_ADMIN'),
    hasPermission: (state) => (code) => state.permissions.includes(code),
  },

  actions: {
    async login(loginForm) {
      try {
        const res = await http.post('/auth/login', loginForm)
        if (res.code === 200) {
          const { accessToken, refreshToken, userInfo, menus } = res.data
          this.token = accessToken
          this.refreshToken = refreshToken
          this.userInfo = userInfo
          this.roles = userInfo.roles || []
          this.permissions = userInfo.permissions || []

          // 启动定时刷新
          initTokenRefresh()

          localStorage.setItem('token', accessToken)
          if (refreshToken) localStorage.setItem('refreshToken', refreshToken)
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          localStorage.setItem('roles', JSON.stringify(this.roles))
          localStorage.setItem('permissions', JSON.stringify(this.permissions))

          // 记住邮箱（不存储明文密码）
          if (loginForm.rememberMe) {
            localStorage.setItem('rememberedEmail', loginForm.email)
            localStorage.setItem('rememberMe', 'true')
          } else {
            localStorage.removeItem('rememberedEmail')
            localStorage.removeItem('rememberMe')
          }

          // 更新权限store
          const permissionStore = usePermissionStore()
          permissionStore.menus = menus || []
          permissionStore.setPermissions(this.permissions)

          return true
        }
        return false
      } catch (error) {
        console.error('登录异常:', error)
        return false
      }
    },

    async refreshToken() {
      const refreshToken = this.refreshToken || localStorage.getItem('refreshToken')
      if (!refreshToken) return false
      try {
        const res = await http.post('/auth/refresh', { refreshToken })
        if (res.code === 200) {
          this.token = res.data.accessToken
          localStorage.setItem('token', res.data.accessToken)
          if (res.data.refreshToken) {
            this.refreshToken = res.data.refreshToken
            localStorage.setItem('refreshToken', res.data.refreshToken)
          }
          initTokenRefresh()
          return true
        }
        return false
      } catch {
        return false
      }
    },

    async fetchProfile() {
      try {
        const res = await http.get('/auth/profile')
        if (res.code === 200) {
          this.userInfo = res.data
          this.roles = res.data.roles || []
          this.permissions = res.data.permissions || []
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          localStorage.setItem('roles', JSON.stringify(this.roles))
          localStorage.setItem('permissions', JSON.stringify(this.permissions))

          const permissionStore = usePermissionStore()
          permissionStore.setPermissions(this.permissions)
          initTokenRefresh()
          return true
        }
        return false
      } catch {
        return false
      }
    },

    async logout() {
      try {
        await http.post('/auth/logout')
      } catch (e) {
        // 忽略
      }
      this.token = ''
      this.refreshToken = ''
      this.userInfo = {}
      this.roles = []
      this.permissions = []
      localStorage.removeItem('token')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('roles')
      localStorage.removeItem('permissions')

      const permissionStore = usePermissionStore()
      permissionStore.resetRoutes()
    },
  },
})
